import { ThemeContext as g } from "@emotion/react";
import { useContext as d, useRef as h } from "react";
import { u as _, m as S, b as A, d as C, e as w, r as O } from "./cleave-react-node-3145b543.js";
import { g as E } from "./lodash-3345fe65.js";
function m() {
  const e = d(
    g
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
function M() {
  const e = _(), r = m();
  return { ...e, theme: r };
}
function j(e, r, n) {
  var t, o;
  if (r == null)
    return r;
  const u = (i) => {
    var s, f;
    return (f = (s = e.__breakpoints) == null ? void 0 : s.asArray) == null ? void 0 : f[i];
  };
  return (o = (t = u(r)) != null ? t : u(n)) != null ? o : n;
}
function T(e, r, n) {
  var t, o;
  if (r == null)
    return r;
  const u = (i) => {
    var s, f;
    return (f = (s = e.__cssMap) == null ? void 0 : s[i]) == null ? void 0 : f.value;
  };
  return (o = (t = u(r)) != null ? t : u(n)) != null ? o : n;
}
function U(e, r, n) {
  const t = m();
  return x(e, r, n)(t);
}
function x(e, r, n) {
  const t = Array.isArray(r) ? r : [r], o = Array.isArray(n) ? n : [n];
  return (u) => {
    const i = o.filter(Boolean), s = t.map((f, a) => {
      var l, y;
      if (e === "breakpoints")
        return j(u, f, (l = i[a]) != null ? l : f);
      const c = `${e}.${f}`;
      return T(u, c, (y = i[a]) != null ? y : f);
    });
    return Array.isArray(r) ? s : s[0];
  };
}
var B = typeof Element < "u", V = typeof Map == "function", P = typeof Set == "function", q = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function p(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, t, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (t = n; t-- !== 0; )
        if (!p(e[t], r[t]))
          return !1;
      return !0;
    }
    var u;
    if (V && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (u = e.entries(); !(t = u.next()).done; )
        if (!r.has(t.value[0]))
          return !1;
      for (u = e.entries(); !(t = u.next()).done; )
        if (!p(t.value[1], r.get(t.value[0])))
          return !1;
      return !0;
    }
    if (P && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (u = e.entries(); !(t = u.next()).done; )
        if (!r.has(t.value[0]))
          return !1;
      return !0;
    }
    if (q && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (n = e.length, n != r.length)
        return !1;
      for (t = n; t-- !== 0; )
        if (e[t] !== r[t])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof r.valueOf == "function")
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof r.toString == "function")
      return e.toString() === r.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(r).length)
      return !1;
    for (t = n; t-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[t]))
        return !1;
    if (B && e instanceof Element)
      return !1;
    for (t = n; t-- !== 0; )
      if (!((o[t] === "_owner" || o[t] === "__v" || o[t] === "__o") && e.$$typeof) && !p(e[o[t]], r[o[t]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var z = function(r, n) {
  try {
    return p(r, n);
  } catch (t) {
    if ((t.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw t;
  }
};
const $ = /* @__PURE__ */ E(z);
function v(e, r = {}) {
  var n;
  const { styleConfig: t, ...o } = r, { theme: u, colorMode: i } = M(), s = e ? S(u, `components.${e}`) : void 0, f = t || s, a = A(
    { theme: u, colorMode: i },
    (n = f == null ? void 0 : f.defaultProps) != null ? n : {},
    C(w(o, ["children"]))
  ), l = h({});
  if (f) {
    const c = O(f)(a);
    $(l.current, c) || (l.current = c);
  }
  return l.current;
}
function W(e, r = {}) {
  return v(e, r);
}
function H(e, r = {}) {
  return v(e, r);
}
export {
  m as a,
  U as b,
  H as c,
  x as g,
  W as u
};
